import * as React from 'react';
import { forwardRef } from 'react';

import { Breakpoints } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

import translate from '../../../utils/translate';

import { ArrowIconComponent, CarIconComponent, HandIconComponent, StaticLinesComponent } from './touch-animations';

export const TouchDeviceOnboarding = forwardRef<HTMLDivElement, { handleClick: () => void }>(({ handleClick }, ref) => {
	return (
		<Wrapper ref={ref} onClick={handleClick}>
			<ClickableArea onClick={handleClick} aria-label={translate('global.ariaLabel.tapToInteract')}>
				<TouchAnimationsWrapper>
					<CarIconComponent />
					<StaticLinesComponent />
					<ArrowIconComponent />
					<HandIconComponent />
				</TouchAnimationsWrapper>
			</ClickableArea>
		</Wrapper>
	);
});

TouchDeviceOnboarding.displayName = 'Touch Device Onboarding';

const Wrapper = styled.div`
	z-index: 2;
	position: relative;
	grid-row: 1 /-1;
	grid-column: 1/-1;

	pointer-events: all;
	background-color: rgba(0, 0, 0, 0.5);
`;

const ClickableArea = styled.button`
	width: 220px;
	height: 250px;
	margin: auto;
	border-radius: 35%;
	display: flex;
	justify-content: center;
	align-items: center;

	// Button reset
	background: transparent;
	border: none;
	padding: 0;
	cursor: pointer;
	outline: none;
	-webkit-appearance: none;
	-moz-appearance: none;

	:focus-visible {
		outline: none;
	}

	&:focus {
		div {
			outline: rgb(76, 199, 244) solid 4px;
		}
	}

	@media (orientation: landscape) {
		width: 250px;
		height: 220px;
	}

	@media (min-width: ${Breakpoints.b960}px) {
		width: 416px;
		height: 542px;
	}

	@media (min-width: ${Breakpoints.b960}px) and (orientation: landscape) {
		width: 542px;
		height: 416px;
	}
`;

const TouchAnimationsWrapper = styled.div`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 176px;
	height: 102px;
	background: rgba(255, 255, 255, 0.8);
	border-radius: 90px;
`;
